/**
 * DeliveryPolicy localized blob display - dual SSOT fail-closed (plan v1.2 G5).
 * Fallback: UI locale -> en -> cs -> null (never blank).
 */
import { normalizeLabelLocale } from 'pi-kiosk-shared';
import type { CustomerDeliveryPolicyDTO, PolicyLocalizedBlob } from './shippingCheckoutApi.js';

export function resolveDeliveryPolicyBlob(
  blob: PolicyLocalizedBlob | null | undefined,
  uiLanguage: string | undefined,
): string | null {
  const pick = (key: 'cs' | 'en'): string | null => {
    const raw = blob?.[key];
    if (typeof raw !== 'string') {
      return null;
    }
    const trimmed = raw.trim();
    return trimmed.length > 0 ? trimmed : null;
  };

  const locale = normalizeLabelLocale(uiLanguage);
  if (locale === 'cs') {
    return pick('cs') ?? pick('en');
  }
  // en, sk, unknown -> en then cs (blobs are cs+en-only V1)
  return pick('en') ?? pick('cs');
}

export function isDeliveryPolicyDisplayReady(
  policy: CustomerDeliveryPolicyDTO | null | undefined,
  uiLanguage: string | undefined,
): boolean {
  if (policy == null) {
    return false;
  }
  if (
    !Number.isFinite(policy.etaMinBusinessDays) ||
    !Number.isFinite(policy.etaMaxBusinessDays) ||
    !Number.isFinite(policy.latestDeliveryBusinessDays)
  ) {
    return false;
  }
  return (
    resolveDeliveryPolicyBlob(policy.priceRangeDescription, uiLanguage) != null &&
    resolveDeliveryPolicyBlob(policy.outOfBandFeeWarning, uiLanguage) != null &&
    resolveDeliveryPolicyBlob(policy.mechanicsDescription, uiLanguage) != null
  );
}